export default "__VITE_ASSET__089ab0b7__"